import React from 'react'
import { stripAllTags } from '@/lib/sanitise-strings'

type TitleProps = {
  title: string
  titleTag?: string
  titleClass?: string
}

export default function Title({ title, titleTag = 'h2', titleClass = 'h2' }: TitleProps) {
  const sanitisedTitle = stripAllTags(title)

  return (
    <div className="component component--title">
      <div className="container @[0px]/single-simple:!max-w-[var(--container-s-max-w)]">
        {sanitisedTitle
          ? React.createElement(titleTag, { className: `${titleClass} mb-0` }, sanitisedTitle)
          : null}
      </div>
    </div>
  )
}
